



















































import { Component, Vue, Prop } from 'vue-property-decorator';

import _ from 'lodash';

import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { curCoreClient, CoreClient } from '@/services/CoreClient';

@Component({
  components:{
    VueError,
    Success,
    SectionHeader,
  }
})
export default class UpdateGroups extends Vue {

  error:string = '';
  success:string = '';
  existingTagList:{key:string,value:string}[] = [];
  internalValueList:{key:string,value:string}[] = [];

  @Prop({ default: '',  type: String}) deviceId!:string;
  @Prop({ default: '',  type: String}) enterpriseId!:string;
  @Prop({ default: () => [],  type: Array}) groupIdList!:string[];
  
  httpBusy:boolean = false;

  private coreClient:CoreClient = curCoreClient;

  async mounted() {

    this.internalValueList = this.groupIdList
      .filter(groupId => !groupId.endsWith('.master'))
      .map(groupId => ({key:groupId, value: groupId.split('.').pop()!}))

    this.refreshEnterpriseGroups();

    this.httpBusy = false;
  }

  async refreshEnterpriseGroups() {

    this.httpBusy = true;

    const reply = await this.coreClient.getEnterprise({enterpriseId:this.enterpriseId});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve enterprise groups: ${reply.errorMsg}`;
    
    // enterprise groups come without the full ID
    this.existingTagList = reply.enterprise!.groupList.map((groupId) => ({key: this.enterpriseId + "." + groupId, value: groupId}));
  }

  async unassignFromAllGroups() {
    this.httpBusy = true;

    this.internalValueList = [];

    const newGroupIdList = [];
    // we add back the master group (which needs to be always there)
    newGroupIdList.push(`${this.enterpriseId}.master`)

    // nothing here yet
    const reply = await this.coreClient.updateDeviceGroups({deviceId:this.deviceId, groupIdList:newGroupIdList});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to update device groups: ${reply.errorMsg}`;

    // Show warning if TPW sync failed, but still show success since DL update succeeded
    if(reply.tpwSync?.attempted && !reply.tpwSync?.success){
      this.success = `Groups updated. Warning: TPW sync failed - ${reply.tpwSync.error || 'changes may not be reflected in ThingPark'}`;
    } else {
      this.success = `Group list for ${this.deviceId} updated successfully`;
    }

    setTimeout( () => { this.$emit('close'); }, 1500)
  }

  async updateGroups() {

    this.httpBusy = true;

    const newGroupIdList = this.internalValueList
      .map(item => `${this.enterpriseId}.${item.value}`)

    // we add back the master group (which needs to be always there)
    newGroupIdList.push(`${this.enterpriseId}.master`)

    // nothing here yet
    const reply = await this.coreClient.updateDeviceGroups({deviceId:this.deviceId, groupIdList:newGroupIdList});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to update device groups: ${reply.errorMsg}`;

    // Show warning if TPW sync failed, but still show success since DL update succeeded
    if(reply.tpwSync?.attempted && !reply.tpwSync?.success){
      this.success = `Groups updated. Warning: TPW sync failed - ${reply.tpwSync.error || 'changes may not be reflected in ThingPark'}`;
    } else {
      this.success = `Group list for ${this.deviceId} updated successfully`;
    }

    setTimeout( () => { this.$emit('close'); }, 1500)
  }

  canCancel():boolean {
    return !this.httpBusy;
  }

  canUpdate():boolean {
    return !this.httpBusy && this.internalValueList.length > 0;
  }

  cancel() {
    this.$emit('close');
  }

}

